import { register } from 'tmr/tmr/ngModuleRegistry'

import * as log from './log'
import * as ngMaterial from './ngMaterial'
import * as paging from './paging'
import * as performance from './performance'
import * as resourceAdmin from './resourceAdmin'
import * as resourceListRoutes from './resourceListRoutes'
import * as translation from './translation'
import * as uiRouter from './uiRouter'

export default register(
  'tmr.core.config',
  log,
  ngMaterial,
  paging,
  performance,
  resourceAdmin,
  resourceListRoutes,
  translation,
  uiRouter
)
